import { File, FolderSimple } from 'phosphor-react';
import { formatDateTime, truncateFileName } from '../../format-converter/utils';
import { formatBytes } from '../utils';

function StorageListView({ items, onOpenFolder, renderItemActions }) {
  return (
    <div className="overflow-auto">
      <table className="w-full min-w-[760px] border-collapse text-left text-sm">
        <thead>
          <tr className="border-b border-slate-200 text-xs uppercase tracking-wide text-slate-500">
            <th className="py-2 pr-3">Name</th>
            <th className="py-2 pr-3">Type</th>
            <th className="py-2 pr-3">Updated</th>
            <th className="py-2 pr-3">Size</th>
            <th className="py-2 pr-3">Actions</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item) => (
            <tr key={item.id} className="border-b border-slate-100">
              <td className="py-2 pr-3">
                {item.type === 'folder' ? (
                  <button type="button" onClick={() => onOpenFolder(item.id)} className="inline-flex items-center gap-2 text-slate-800">
                    <FolderSimple size={16} weight="bold" className="text-amber-700" />
                    {truncateFileName(item.name || 'Untitled folder', 44)}
                  </button>
                ) : (
                  <span className="inline-flex items-center gap-2 text-slate-800">
                    <File size={16} weight="bold" className="text-slate-500" />
                    {truncateFileName(item.name || '-', 44)}
                  </span>
                )}
              </td>
              <td className="py-2 pr-3 capitalize">{item.type || '-'}</td>
              <td className="py-2 pr-3 text-slate-600">{formatDateTime(item.updatedAt)}</td>
              <td className="py-2 pr-3 text-slate-600">{item.type === 'folder' ? '-' : formatBytes(item.size)}</td>
              <td className="py-2 pr-3">{renderItemActions(item)}</td>
            </tr>
          ))}
          {!items.length && (
            <tr>
              <td className="py-4 text-slate-500" colSpan={5}>
                No items in this folder.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default StorageListView;
